/* eslint-disable class-methods-use-this */
/* eslint-disable import/prefer-default-export */
import { getTokenAndKey } from '.';
import { Storage } from './storage';
import { LOGIN_RESULT } from '../const/no-magic-string';
import { UBTUtils } from './ubt';

export const UserUtils = new (class {
  getTokenAndKey = getTokenAndKey

  setUserInfo(v) {
    if (v) {
      Storage.setItem(LOGIN_RESULT, v);
      UBTUtils.init(true);
    }
  }
})();
